import ExcludeFromLookup from '../../../../../../enums/ExcludeFromLookup';
import required from '../../../../../form/field-validation/required';
import stripCharacters from '../../../../../utils/strip-characters';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import postalId from '../../defaultFieldDefinitions/PostalId';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import enabledSetting from '../../enabledSetting';
import * as max from '../../max-length-validators';
import {fiveDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';

const isRequired = !!enabledSetting('company_name_is_required');
const siteSpecificAddressRules = enabledSetting('site_specific_address_rules')?.de;
const hideCompanyName = !!enabledSetting('hide_company_name');

const formatDEPostcode = (value) => {
  if (!value) return value;
  return value.replace(/\s/g, '');
};

let FieldDefinitionDE = null;

if (window.start?.settings?.should_use_alternate_address_definition_de) {
  FieldDefinitionDE = [
    addressee,
    {
      name: 'companyName',
      label: 'checkout.delivery.address.field.label.company.name.text',
      hideCondition: hideCompanyName,
      maxLength: siteSpecificAddressRules?.companyName?.length || 35,
      get validate() {
        return isRequired
          ? [required('company'), max.lengthCompany(this.maxLength)]
          : max.lengthCompany(this.maxLength);
      },
      required: isRequired,
      excludeFromAddressLookup: ExcludeFromLookup.BEFORE,
    },
    streetName,
    nameNumber,
    addressLine2,
    {
      ...postalId,
      excludeFromAddressLookup: ExcludeFromLookup.AFTER,
    },
    {
      name: 'postCode',
      label: 'checkout.delivery.address.field.label.postal.code.text',
      required: true,
      maxLength: 5,
      transform: formatDEPostcode,
      validate: [required('postcode'), max.lengthPostCode(5), fiveDigitsPostcodeValidator],
      validationCleaner: stripCharacters(' '),
    },
    townCity,
    county,
  ];
} else {
  FieldDefinitionDE = [
    addressee,
    {
      name: 'companyName',
      label: 'checkout.delivery.address.field.label.company.name.text',
      hideCondition: hideCompanyName,
      maxLength: siteSpecificAddressRules?.companyName?.length || 35,
      get validate() {
        return isRequired
          ? [required('company'), max.lengthCompany(this.maxLength)]
          : max.lengthCompany(this.maxLength);
      },
      required: isRequired,
      excludeFromAddressLookup: ExcludeFromLookup.BEFORE,
    },
    streetName,
    addressLine2,
    nameNumber,
    {
      ...postalId,
      excludeFromAddressLookup: ExcludeFromLookup.AFTER,
    },
    {
      name: 'postCode',
      label: 'checkout.delivery.address.field.label.postal.code.text',
      required: true,
      maxLength: 5,
      transform: formatDEPostcode,
      validate: [required('postcode'), max.lengthPostCode(5), fiveDigitsPostcodeValidator],
      validationCleaner: stripCharacters(' '),
    },
    townCity,
    county,
  ];
}

const modifiedFieldDefinitionDE = window.start?.settings?.should_display_packstation_field
  ? FieldDefinitionDE
  : FieldDefinitionDE.filter(field => field.name !== 'postalId');

export default modifiedFieldDefinitionDE;
